import React from 'react';
import Box from '@material-ui/core/Box';

const BetaNavBadge = ({ style: outerStyle }) => (
    <Box
        component="span"
        aria-hidden
        style={{
            position: 'absolute',
            top: -5,
            right: -4,
            backgroundColor: '#ef4444',
            color: 'white',
            fontSize: 8,
            fontWeight: 600,
            padding: '2px 4px',
            borderRadius: 3,
            lineHeight: 1,
            whiteSpace: 'nowrap',
            ...outerStyle,
        }}
    >
        Beta
    </Box>
);

export default BetaNavBadge;
